import { useAppDispatch } from 'universal-scripts'
import { useUserAcl } from '@hooks/useUserAcl'
import { openTrialDialog } from 'src/store/slices/ui'

export function useTrialGuard() {
  const dispatch = useAppDispatch()
  const acl = useUserAcl()
  const isTrial = acl.includes('trial')

  const guard = <TArgs extends unknown[], TReturn>(
    fn: (...args: TArgs) => TReturn
  ) => {
    return (...args: TArgs): TReturn | void => {
      if (isTrial) {
        dispatch(openTrialDialog())
        return
      }
      return fn(...args)
    }
  }

  return { isTrial, guard }
}
